module.exports = __webpack_public_path__ + "HomeMarker-aL8qJPl.svg";